import { recoveryColumns } from "../columns";
import { WithTitle } from "../shared";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";

type TProps = {
  resourceRecoveryDetails: object;
};

const ResourceRecovery: React.FC<TProps> = ({ resourceRecoveryDetails }) => {
  const finalData = Object.values(resourceRecoveryDetails);

  return (
    <WithTitle title='Resource Recovery Dashboard' className='p-4 min-w-0'>
      <p className='text-sm'>
        This report summarises the resource recovery outcomes of the project,
        collating data from the inventory stage through to the contracting and
        reporting of material diversion. The summary page is referenced to the
        &apos;BBP Waste Management Report&apos; and provides a high level
        summary of reuse and recycling activities for stakeholders.
      </p>
      {/* <DataTable
        columns={recoveryColumns}
        data={finalData?.length ? finalData : []}
      /> */}
      <CustomTable
        empty={{
          subtitle: "Resource recovery data seems to be empty",
          small: true,
        }}
        title='Resource Recovery'
        data={finalData}
        columns={recoveryColumns}
        filters={false}
        hideFilterRow
        id='resource-recovery'
        hide={{
          filters: true,
          functions: true,
        }}
      />
    </WithTitle>
  );
};

export default ResourceRecovery;
